import { CLEAN_LEAD_ASSIGNMENT, CLEAN_LEAD_ASSIGNMENT_ERROR } from '_models/redux/types';

export const cleanLeadAssignmentAction = () => async (dispatch) => {
  try {
    dispatch({
      type: CLEAN_LEAD_ASSIGNMENT,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_LEAD_ASSIGNMENT_ERROR,
      payload: undefined,
    });
  }
};
